import React from 'react';
import PropTypes from 'prop-types';
import './NewsCard.scss';
import { Link } from 'react-router-dom';
import ArrowBtn from '../../common/arrow_btn';

const ConditionalWrapper = ({ condition, wrapperHref, wrapperLink, children }) => condition ? wrapperHref(children) : wrapperLink(children);

const NewsCard = ({ url, date, title, subtitle, poster, isFeatured, external }) => {
  return (
      <ConditionalWrapper
        condition={external}
        wrapperHref={children => <a href={external} target="_blank" rel='noreferrer noopener'>{children}</a>}
        wrapperLink={children => <Link to={url}>{children}</Link>}
      >
          <div
              className='news__card'
              data-featured={isFeatured ? isFeatured : 'no_isFeatured'}
          >
              <div
                  style={{ backgroundImage: `url('${poster}')` }}
                  className='news__card__poster'
              />
              <p
                  className='news__card__date'
                  dangerouslySetInnerHTML={{ __html: date }}
              />
              <div className='news__card__text'>
                  <h4 className='title' dangerouslySetInnerHTML={{ __html: title }} />
                  <p
                      className='subtitle'
                      dangerouslySetInnerHTML={{ __html: subtitle }}
                  />

                  <ArrowBtn buttonClass='card__btn' buttonColor='black' url={url} title='Read more' disableUrl/>

              </div>
          </div>
      </ConditionalWrapper>
  );
};

NewsCard.propTypes = {
  url: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  poster: PropTypes.string.isRequired,
  isFeatured: PropTypes.bool.isRequired,
};

export default NewsCard;
